import * as React from 'react';

import { OnDeleteItemType } from '../../Cart/types';
import { useConfig } from '../../context';
import { ServiceSummary } from '../../features/service-summary';

interface Props {
	children: (content: React.ReactNode) => React.ReactElement;
	segmentId?: string;
	onServiceDelete?: OnDeleteItemType;
	isAnimalBaggage?: boolean;
}

const BaggageSummary: React.FC<Props> = ({ isAnimalBaggage, onServiceDelete, segmentId, ...props }) => {
	const {
		global: {
			servicesAvailable: { animal: availableAnimal }
		}
	} = useConfig();

	return (
		<ServiceSummary
			serviceType={availableAnimal && isAnimalBaggage ? 'Animal' : 'Baggage'}
			onDelete={onServiceDelete}
			segmentId={segmentId}
		>
			{content => props.children(content)}
		</ServiceSummary>
	);
};

export default BaggageSummary;
